/**
 * Operator sign-in for the operator console. In production Cloudflare Access (single sign-on) fronts /ops
 * and the browser carries its cookie, so no token is sent. In development the API accepts
 * `dev-op:<email>` for an operator in the control plane; it lives only for this browser tab.
 */
const KEY = 't4-ops-dev'

export function opsToken(): string | null {
  try { return sessionStorage.getItem(KEY) } catch { return null }
}

export function setOpsDevEmail(email: string | null) {
  try {
    if (email) sessionStorage.setItem(KEY, `dev-op:${email.trim().toLowerCase()}`)
    else sessionStorage.removeItem(KEY)
  } catch { /* storage blocked */ }
}
